module.exports = __webpack_public_path__ + "img/784a486.jpg";